import * as React from "react";
import styled from "@mui/material/styles/styled";
import { featureToLines, getQFAndRefinementsLines } from "fe-common/logic";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { StrengthIcon } from "../supportingWeakeningWidget";
import { Suggestion } from "../hooks/useSuggestions";
import { useFindingClinicalReason } from "../refineFeature/useFindingClinicalReason";
import { Qualifier } from "fe-common/graphql";
//import { Grow } from "@mui/material";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";

//region [[ Styles ]]

const ClinicalReasoningTooltipView = styled("div")({});

const DiseaseItem = styled("div")({
  display: "block",
});

const Title = styled("div")({
  marginBottom: "5px",
  color: KahunColorMap.Primary,
});

const TopArea = styled("div")({
  display: "flex",
});

const DiseaseWithStrength = styled("div")({
  display: "flex",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicalReasoningTooltipProps {
  className?: string;
  suggestion: Suggestion;
  qualifier?: Qualifier;
  show: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicalReasoningTooltip = ({
  ...props
}: ClinicalReasoningTooltipProps) => {
  const [findingTitle, qualifiersText] = getQFAndRefinementsLines(
    props.suggestion.finding,
  );

  const diseasesStrength = useFindingClinicalReason(
    props.suggestion?.causedByDisease,
  )(props.qualifier ? props.qualifier : null);

  const title = !props.qualifier ? findingTitle : props.qualifier.value.name;

  return (
    <ClinicalReasoningTooltipView className={props.className}>
      {props.show && (
        //<Grow in={props.show}>
        <>
          <TopArea>
            <Title>
              {title} {qualifiersText?.toLowerCase() || ""} supports
            </Title>
          </TopArea>
          {diseasesStrength.map((diseaseItem) => (
            <DiseaseWithStrength key={diseaseItem.disease.id}>
              <StrengthIcon
                strength={diseaseItem.strength}
                supporting={"true"}
                iconcolor={RosebudColorMap.green2}
              />
              <DiseaseItem>{featureToLines(diseaseItem.disease)}</DiseaseItem>
            </DiseaseWithStrength>
          ))}
        </>
        //</Grow>
      )}
    </ClinicalReasoningTooltipView>
  );
};
